import { Pie, ResponsivePie } from "@nivo/pie"
import { PieChartData } from "./PieChartColorFromData"


const PieChartNoLegends = ({data, dataType, centerText = "", width, height}:{data:PieChartData[], dataType: string, centerText?: string, width:number | undefined, height:number | undefined}) => {
    const isAllZeros = data.every(entry => entry.value === 0)
    let displayData = data

    if (isAllZeros) {
        displayData = [{id: ``, label: `No ${dataType}`, value: 1, color: "rgb(209 213 219)"}]
    }

    return (
        <div className="flex relative w-full h-full justify-center items-center place-self-center">
           <div className="absolute inset-0 flex justify-center items-center z-10 pointer-events-none">
                <div className="text-center font-medium">
                    {isAllZeros ? `No ${dataType}` : centerText}
                </div>
            </div> 
            { width && height ?
            <Pie
                data={displayData}
                margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                innerRadius={0.7}
                padAngle={0.2}
                cornerRadius={1}
                activeOuterRadiusOffset={4}
                colors={{ datum: "data.color" }}
                enableArcLabels={false/*!isAllZeros*/}
                arcLabel={(data) => (data.value !== 0 ? `${data.value}` : "")}
                enableArcLinkLabels={isAllZeros}
                arcLinkLabelsTextColor="#6b7280"
                arcLinkLabelsThickness={0}
                arcLinkLabelsOffset={-80}
                arcLinkLabelsTextOffset={-45}
                width={width}
                height={height}
            />
            :
            <ResponsivePie
                data={displayData}
                margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                innerRadius={0.7}
                padAngle={0.7}
                cornerRadius={1}
                activeOuterRadiusOffset={4}
                colors={{ datum: "data.color" }}
                enableArcLabels={false}
                arcLabel={(data) => (data.value !== 0 ? `${data.value}` : "")}
                enableArcLinkLabels={isAllZeros}
                arcLinkLabelsTextColor="#6b7280"
                arcLinkLabelsThickness={0}
                arcLinkLabelsOffset={-80}
                arcLinkLabelsTextOffset={-45}
            />}
        </div>
    )
}

export default PieChartNoLegends